<!--
    EiToolingObjectSearchTabComponent Template

    Core workflow:
      1. Choose the record structure to assign
      2. Search an object of that type via AutoComplete
      3. Preview the chosen object
      4. "Zuweisen und Re-Lookup ausführen"
-->

<div class="flex flex-column gap-3">

    <!-- Step 1: Structure selection -->
    <div>
        <label class="text-sm text-600 block mb-1">
            1. Welche Struktur soll zugewiesen werden?
        </label>
        <p-select
                [options]="structureOptions"
                [(ngModel)]="selectedStructure"
                (onChange)="onStructureChange()"
                optionLabel="label"
                placeholder="Struktur wählen"
                styleClass="w-full"
                appendTo="body">
            <ng-template let-item pTemplate="selectedItem">
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-cube text-500"></i>
                    <span>{{ item?.label }}</span>
                    @if (item?.assignmentStatusLabel) {
                        <p-tag [value]="item.assignmentStatusLabel" class="ml-2"></p-tag>
                    }
                </div>
            </ng-template>
            <ng-template let-item pTemplate="item">
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-cube text-500"></i>
                    <span>{{ item?.label }}</span>
                    @if (item?.assignmentStatusLabel) {
                        <p-tag [value]="item.assignmentStatusLabel" class="ml-2"></p-tag>
                    }
                </div>
            </ng-template>
        </p-select>
    </div>

    <!-- Step 2: Search -->
    @if (selectedStructure) {

        @if (serviceMissingWarning) {
            <p-message
                    severity="warn"
                    [text]="serviceMissingWarning"
                    [closable]="false">
            </p-message>
        } @else {
            <div>
                <label class="text-sm text-600 block mb-1">
                    2. Suche nach {{ selectedStructure.objectTypeName }}
                </label>
                <p-autoComplete
                        placeholder="Mindestens 2 Zeichen eingeben…"
                        [(ngModel)]="selectedObject"
                        [suggestions]="filteredData"
                        (completeMethod)="filterObjects($event)"
                        optionLabel="displayName"
                        [dropdown]="true"
                        [minLength]="2"
                        [forceSelection]="true"
                        (onSelect)="onPreviewSelect($event.value)"
                        styleClass="w-full"
                        appendTo="body">
                    <ng-template let-object pTemplate="item">
                        <div class="flex align-items-center gap-2">
                            <i class="fa-regular fa-cube text-500"></i>
                            <div class="flex flex-column">
                                <span>{{ object?.displayName }}</span>
                                <span class="text-xs text-500">#{{ object?.id }}</span>
                            </div>
                        </div>
                    </ng-template>
                </p-autoComplete>
            </div>
        }

    }

    <!-- Step 3: Preview -->
    @if (previewObject) {
        <div class="surface-card shadow-1 border-round p-3">
            <h5 class="m-0 mb-2">Vorschau</h5>
            <div class="surface-100 border-round p-2 mb-3">
                @if (previewFields.length > 0) {
                    <div class="grid">
                        @for (field of previewFields; track field.key) {
                            <div class="col-6">
                                <div class="text-xs text-600">{{ field.label }}</div>
                                <div>{{ field.value }}</div>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="text-sm text-600">
                        Keine zusätzlichen Vorschaudaten verfügbar.
                    </div>
                }
            </div>

            <div class="flex justify-content-end gap-2">
                <p-button
                        label="Abbrechen"
                        severity="secondary"
                        [text]="true"
                        (onClick)="cancelPreview()">
                </p-button>
                <p-button
                        label="Zuweisen und Re-Lookup ausführen"
                        icon="fa-solid fa-check"
                        severity="primary"
                        [loading]="assigning"
                        (onClick)="assignAndReLookup()">
                </p-button>
            </div>
        </div>
    }

    <p-message
            severity="info"
            text="Die manuelle Zuweisung fügt das Objekt hinzu und führt automatisch einen erneuten Lookup auf Record-Ebene aus."
            [closable]="false">
    </p-message>

</div>
